import { TRACK_EVENT } from '@tkww/the-bash-frontend';
import { HYPERLINK_CTA_STYLE, CTA_CLICK, BUTTON_CTA_STYLE } from 'analytics/constants';

export const eventBlurbCtaClick = (clickArea, clickDestination, titleTag) => ({
  type: TRACK_EVENT,
  name: CTA_CLICK,
  properties: {
    clickArea,
    clickDestination,
    ctaStyle: HYPERLINK_CTA_STYLE,
    title: titleTag,
  },
});
